export const CERTIFICADOPUSH = 'BLKSnXHIlTO294U5I1400T2vazZQGE9VfBcIa0q8c7KEH3B_r2Dxw8ohXl-y2irYlmUI9-qe05CJ_Qz3n6VzJMo'

export const URLAPI = 'https://internationallogisticsmd.com/notis/firebasepush.php'

export const IDPROYECTO = 'pagina-web-a51b5'